<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="런치팩 고객 1:1문의"
      desc="서비스 개설한 고객들의 1:1 문의 목록을 볼수있습니다.">
      <!-- 문의 카테고리 -->
      <div slot="inquiry_category">
        <span class="select">
          <select @change="selectCategory">
            <option value="" disabled selected>카테고리</option>
            <option v-for="(cat, idx) in cats"
                    :key="'cat'+idx"
                    :value="cat.value">{{ cat.label }}</option>
          </select>
        </span>
      </div>

      <div slot="status">
        <span class="select">
            <select @change="filterStatus">
              <option value="" disabled selected>전체</option>
              <option :value="item.value"
                      v-for="(item,idx) in statusOptions" :key="'status-'+idx"
              >{{ item.label }}</option>
            </select>
        </span>
      </div>
    </admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push(getPath('launchpack/inquiry/customer/create'))"
              class="button is-primary">1:1문의 등록</button>

      <button class="button" style="width:150px" @click="DownloadFile()">
        <img style="width: 10px;margin-right: 4px;"
             src="~assets/image/excel_icon.png"/>
        <span>문의 내역 다운로드</span></button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="title" slot-scope="props" class="unselect" style="text-decoration:underline">
        <div @click="$router.push(`customer/create?id=${props.item.id}`)">{{ props.item.title }}</div>
      </div>

      <div slot="status" slot-scope="props">
        <span class="select">
          <select v-model="props.item.status" @change="e=>selectStatus(e.target.value, props.item)">
            <option value="" disabled selected>{{ selectedStatus(props.item.status) }}</option>
            <option v-for="(item,idx) in statusOptions" :key="'status-'+idx"
                    :value="item.value">{{ item.label }}</option>
          </select>
        </span>
      </div>

      <div slot="status_button" slot-scope="props">
        <button class="button btn-confirm" @click="changeStatus(props.item, 1)" v-if="props.item.status===0">신규문의확인</button>
        <button class="button btn-process" @click="changeStatus(props.item, 2)" v-if="props.item.status===1">진행중</button>
        <button class="button btn-success" @click="changeStatus(props.item, 3)" v-if="props.item.status===2">진행완료</button>
        <div v-else-if="props.item.status===3">-</div>
      </div>

      <div slot="comment_status" slot-scope="props" style="width: 120px; margin: auto;">
        <div v-if="props.item.is_answered">답변 완료</div>
        <div v-else>답변 대기</div>
      </div>

      <div slot="is_new" slot-scope="props">
        <div v-if="props.item.is_new">확인</div>
        <div v-else>미확인</div>
      </div>

      <div slot="detail" slot-scope="props">
        <button v-if="props.item.is_answered"
                class="button is-grey cancel"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 수정</button>
        <button v-if="!props.item.is_answered"
                class="button state-btn btn-make-comment"
                @click.stop.prevent="clickAnswer(props.item.id)">답변 달기</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {

    mixins: [
      ListMixin  // 목록페이지의 공통적인 데이터 및 함수는 List.js에 다 구성되어 있다.
    ],
    data() {
      return {
        cats: [],
        statusOptions: [
          { label: '미확인', value: 0 },
          { label: '진행중', value: 2 },
          { label: '완료', value: 3 },
        ]
      }
    },
    created(){
      this.init();
    },
    methods: {
      init () {
        /* 테이블, 필터를 구성할 structure_path, url을 파라미터로 넘겨준다.
      *  structure.js에 structure_path에 맞게 데이터를 생성한다.
      *  해당 url에 맞게 axios 호출이 잘되는지 확인한다.
      * */
        this.initializing('launchpack_customer_inquiry', 'launchpack/inquiry/customer');
        this.getCategory();
      },
      getDataFromServer() {
        this.getData();
      },
      filterStatus(e) {
        this.filtered.status = e.target.value;
        this.getData();
      },
      selectedStatus(val) {
        switch(val) {
          case 0:
            return '미확인';
            break;
          case 2:
            return '진행중';
            break;
          case 3:
            return '완료';
            break;
        }
      },
      selectStatus(val, item) {
        this.$axios.post(this.getUrl(`launchpack/inquiry/customer/${item.id}/status/change`), {
          status: val
        }).then(res=>{
          if(res.status===200) {
            this.toast('상태가 변경되었습니다.');
            item.status=parseInt(val);
          }
        })
      },
      getCategory() {
        this.$axios.get(this.masterBackendUrl + 'public/launchpack/inquiry/customer/category').then(res=>{
          this.cats = res.data;
        })
      },
      changeStatus(item, status) {
        this.$axios.post(this.getUrl(`launchpack/inquiry/customer/${item.id}/status/change`), {
          status: status
        }).then(res=>{
          if(res.status===200) {
            item.status=status;
          }
        })
      },
      // 문의 카테고리 선택
      selectCategory(e) {
        this.filtered.category = e.target.value;
        this.getData();
      },
      // 답변 달기
      clickAnswer(id){
        this.$router.push(this.getPath('launchpack/inquiry/customer/create?id='+id));
      },
      DownloadFile() {
        this.$axios.get(this.getUrl(`launchpack/inquiry/customer/download`), {
          params: this.filtered,
          responseType: 'arraybuffer',
        }).then(response=> {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let blobURL = window.URL.createObjectURL(blob);
          let tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', '문의내역.xlsx');
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
